import React from "react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"

const HeroBlock = ({ block }) => {
  return (
    <section className="pb-16 lg:pb-32">
      <div className="text-white bg-secondary">
        <div className="lg:pt-12 block-w-container">
          <div className="flex flex-row flex-wrap -mx-grid">
            <div className="w-full lg:w-1/2 lg:order-last px-grid">
              <div className="-mx-8 lg:mx-0 lg:-mb-16 h-[60vh] lg:h-auto overflow-hidden">
                <Image
                  className="block object-cover w-full h-full lg:w-full lg:h-auto"
                  image={block.image}
                />
              </div>
            </div>
            <div className="w-full lg:w-1/2 px-grid">
              <div className="pt-4 pb-8 lg:pt-0">
                <HeadlineEnhanced
                  kicker={block.kicker}
                  headline={block.headline}
                  subheadline={block.subheadline}
                  headlineLevel="h3"
                  tagName="h1"
                />
                <Richtext className="mt-4 text-white" text={block.text} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="hidden w-full h-32 bg-white lg:block"></div> */}
    </section>
  )
}

export default HeroBlock
